import { resetSelection, singleSelectRow } from 'owa-mail-actions';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Auto selects the first appropriate row in table
 * @param tableView in which to select the first row
 */
function autoSelectFirstRow(tableView) {
    var tableRowKeys = tableView.rowKeys;
    var tableRowsLength = tableRowKeys.length;
    if (tableRowsLength > 0) {
        var i = 0;
        var rowToSelect = tableRowKeys[i];
        // Find first pinned and unread row, or non-pinned row
        while (i < tableRowsLength) {
            var isRowPinned = MailRowDataPropertyGetter.getIsPinned(tableRowKeys[i], tableView);
            var unreadCount = MailRowDataPropertyGetter.getUnreadCount(tableRowKeys[i], tableView);
            if (!isRowPinned || unreadCount > 0) {
                rowToSelect = tableRowKeys[i];
                break;
            }
            i++;
        }
        // Select the row
        singleSelectRow(tableView, rowToSelect, false /* isUserNavigation */, MailListItemSelectionSource.Auto);
    }
}
/**
 * Initializes selection on table load based on user's settings
 * @param tableView the table view
 * @param state the InitTableSelectionOnLoadState
 */
export default action('initTableSelectionOnLoad')(select({
    showReadingPaneOnFirstLoad: function () {
        return getUserConfiguration().UserOptions.ShowReadingPaneOnFirstLoad;
    },
})(function initTableSelectionOnLoad(tableView, state) {
    // Select first row according to user options if not in junk folder,
    // otherwise re-init selection in table
    if (state.showReadingPaneOnFirstLoad &&
        tableView.tableQuery.folderId != folderNameToId('junkemail')) {
        autoSelectFirstRow(tableView);
    }
    else {
        resetSelection(tableView, MailListItemSelectionSource.Reset);
    }
}));
//# sourceMappingURL=initTableSelectionOnLoad.js.map